import "./LoanDetails.css";
import { useState, useEffect } from "react";
import LOSModal from "../../../../Borrower/BorrowerDetails/Components/Modals/LOSModal/LOSModal";
import axios from "axios";
import { url } from "../../../../../App";
import Cookies from 'js-cookie';
import { toast } from "react-toastify";

const mainDetails = [
  {
    title: "Loan Status",
    apiName: "loan_status",
  },
  {
    title: "Collected By",
    apiName: "collection_by",
  },
  {
    title: "Loan Application ID",
    apiName: "loan_id",
  },
  {
    title: "NBFC Name",
    apiName: "nbfc_name",
  },
  {
    title: "Loan Product",
    apiName: "loanproduct_name",
  },
];

const LoanDetails = ({
  loanDetails = {},
  dateFunction,
  arrayLength,
  loanArr,
}) => {
  console.log(loanDetails,"loanDetails");

  const [visible, setvisible] = useState(false);
  const [MailButtonVisible, setMailButtonVisible] = useState(false);
  const loanTerms = loanDetails.docs || {};
  const [losModal, setLosModal] = useState(false);
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  const [disableInsuranceButton, setDisableInsuranceButton] = useState(false);

  useEffect(() => {
    if (email === "rupesh.bishnoi@credin.in") {
      setvisible(true);
    } else {
      console.log(token);
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email
        })
        .then((res) => {
          console.log(res);
          setMailButtonVisible(res.data[0].permission.initiate_cattle_insurance);
        })
        .catch((err) => {
          // console.log(err);
        })
    };
    //eslint-disable-next-line
  }, [token]);

  useEffect(() => {
    if (loanDetails.docs?.insurance_mail_sender) {
      setDisableInsuranceButton(true);
    }
  }, [loanDetails.docs]);

  const handleLosID = () => {
    setLosModal(true);
  };

  const closeLosModal = () => {
    setLosModal(false);
  };

  const capitalizeFirstLetter = (string) => {
    if (!string) return "N/A";
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  console.log(loanTerms)

  const handleButtonClick = async (loanterms) => {
    console.log(loanterms.loan_id);

    const mail = await axios.post(url + '/loan/insurance/mail', {
      email: email,
      token: token,
      loanNo: loanterms.loan_id,
    });

    console.log(mail);

    if (mail.data.auth === true) {
      toast.success('Mail Sent Successfully');
    } else {
      toast.error(mail.data.message);
    }
  }

  return (
    <>
      {losModal && (
        <LOSModal closeModal={closeLosModal} loanId={loanTerms?.loan_id} />
      )}
      <div className="loan-details">
        <div className="loan-status">
          {mainDetails?.map((item) => {
            return (
              <div key={item.apiName}>
                <p>{item.title}</p>
                <p>
                  {loanTerms[item?.apiName] ? loanTerms[item?.apiName] : "N/A"}
                </p>
              </div>
            );
          })}
          <div>
            <p>NBFC LOS ID</p>
            <p>
              {loanTerms?.nbfc_los_id}
              <button style={{ marginLeft: "2vw" }} onClick={handleLosID}>
                Update
              </button>
            </p>
          </div>
        </div>
        <h2>Loan Calculation</h2>
        <div className="loan-terms">
          <div>
            <p>Principal Amount</p>
            <p>{loanTerms?.loan_principal_amt ?? "N/A"}</p>
          </div>
          {loanArr?.map((data) => {
            console.log(data);
            return (
              <div key={data.loanfees_id}>
                {/* <p>{data.loanfees_name ?? "N/A"}</p> */}
                <p>{capitalizeFirstLetter(data?.loanfees_name) ?? "N/A"}</p>
                <p>{Math.round(data?.loanfees_amount) ?? "N/A"}</p>
                {/* <p>{data.loanfees_amount} </p> */}
              </div>
            );
          })}
          <div>
            <p>Pre EMI Interest</p>
            <p>{loanTerms?.loan_pre_emi_interest ?? "N/A"}</p>
          </div>
          <div>
            <p>Life Insurance Amount</p>
            <p>{loanTerms?.loan_life_ins ?? "N/A"} </p>
          </div>
          <div>
            <p>Cattle Insurance Amount</p>
            <p>{loanTerms?.loan_cattle_ins ?? "N/A"}
              {loanTerms?.loan_cattle_ins && 
                (MailButtonVisible || visible) && (
                  <button
                    style={{ 
                      padding: "5px", 
                      margin: "4px", 
                      color: "white", 
                      background: disableInsuranceButton ? "#d3d3d3" : "#0000ff", 
                      borderRadius: "5px", 
                      border: "none", 
                      cursor: disableInsuranceButton ? "not-allowed" : "pointer",
                      opacity: disableInsuranceButton ? 0.9 : 1, 
                    }}
                    onClick={() => handleButtonClick(loanTerms)}
                    disabled = {disableInsuranceButton}
                  >
                    Trigger Mail for Insurance
                  </button>
                )
              }
            </p>
          </div>
          <div>
            <p>Property Insurance Amount</p>
            <p>{loanTerms?.loan_property_ins ?? "N/A"} </p>
          </div>    
          <div>
            <p>Net disbursment amount</p>
            <p>{loanTerms?.loan_disbursed_amt ?? "N/A"}</p>
          </div>
          <h2>Tranche Details</h2>
          <div>
            <p>Number of Tranches</p>
            <p>{loanTerms?.loan_tranche_number ?? "N/A"}</p>
          </div>
          {loanTerms?.loan_tranche_arr?.map((term) => {
            return (
              <>
                <div>
                  <p>Tranche Number</p>
                  <p>{term.trancheNumber}</p>
                </div>
                <div>
                  <p>Tranche Release Date</p>
                  <p>{dateFunction(term.trancheReleaseDate)}</p>
                </div>
                <div>
                  <p>Tranche Amount</p>
                  <p>{term.trancheAmount}</p>
                </div>
                <div>
                  <p>UTR No.</p>
                  <p>{term.trancheUtr? term.trancheUtr : "N/A"}</p>
                </div>
                <div>
                  <p>Tranche Principal Amount</p>
                  <p>{term.tranchePrinAmount? term.tranchePrinAmount : "N/A"}</p>
                </div>
              </>
            );
          })}
          <h2>Loan Details</h2>
          <div>
            <p>APR (as per IRR)</p>
            <p>{loanTerms?.APRasPerIRR ?? "N/A"} </p>
          </div>
          <div>
            <p>Loan Type</p>
            <p>{loanTerms?.loan_type ?? "N/A"}</p>
          </div>
          <div>
            <p>Pending Principal Amount</p>
            <p>{loanTerms?.pending_principal ?? "N/A"}</p>
          </div>
          <div>
            <p>Pending Interest</p>
            <p>{loanTerms?.pending_interest ?? "N/A"}</p>
          </div>
          <div>
            <p>Pending Charges</p>
            <p>{loanTerms?.pending_charges ?? "N/A"}</p>
          </div>
          <div>
            <p>Loan Interest Method</p>
            <p>{loanTerms?.loanproduct_interest_method}</p>
          </div>
          <div>
            <p>Loan Interest</p>
            <p>{loanTerms?.loanproduct_interest_rate ?? "N/A"}</p>
          </div>
          <div>
            <p>Total Interest Amount</p>
            <p>{loanDetails?.total_int_amt ?? "N/A"}</p>
          </div>
          <div>
            <p>Loan Duration</p>
            <p>{loanTerms?.loan_duration ?? "N/A"}</p>
          </div>
          <div>
            <p>Number of Repayments</p>
            <p>{arrayLength(loanTerms?.loan_repayment)}</p>
          </div>
          <div>
            <p>Loan Release Date</p>
            <p>{dateFunction(loanTerms?.loan_release_date)}</p>
          </div>
          <div>
            <p>EMI Amount</p>
            <p>{loanTerms?.loan_emi_amt ?? "N/A"}</p>
          </div>
          {/* {loanArr.map((loanFee) => (
            <>
              {Object.entries(loanFee).map(([key, value]) => (
                <div>
                  <p>{key}</p>
                  <p>{value}</p>
                </div>
              ))}
            </>
          ))} */}

          <div>
            <p>EMI Start Date</p>
            <p>{dateFunction(loanTerms?.loan_emi_start_date) ?? "N/A"}</p>
          </div>
          <div>
            <p>EMI End Date</p>
            <p>{dateFunction(loanTerms?.loan_emi_last_date) ?? "N/A"}</p>
          </div>
          <div>
            <p>Closed Data</p>
            <p>{dateFunction(loanTerms?.loan_close_date)}</p>
          </div>

          <div>
            <p>CPV Agent</p>
            <p>{loanTerms?.cpv_agent ?? "N/A"}</p>
          </div>

          {loanDetails.loanproduct_group === "DAIRY LOAN" &&(
            <>
              <div>
                <p>Number of Cows</p>
                <p>{loanTerms?.number_of_cow ?? "N/A"}</p>
              </div>

              <div>
                <p>Number of buffalo</p>
                <p>{loanTerms?.number_of_buffalo ?? "N/A"}</p>
              </div>
            </>
          )}


          {/* 
          <div>
            <p>Tranche No.</p>
            <p>{loanTerms?.loan_tranche_number ?? "N/A"}</p>
          </div> */}
          {/* <div>
            <p>Disbursment to customer</p>
            <p>{loanTerms?.loan_tranche_number ?? "N/A"}</p>
          </div> */}
        </div>
        {/* <h2>Advanced Settings</h2>
        <div className="adv-settings">
          <div>
            <p>Decimal Places</p>
            <p>no data</p>
          </div>
          <div>
            <p>Interest Start Date</p>
            <p>no data</p>
          </div>
          <div>
            <p>First Repayment Date</p>
            <p>no data</p>
          </div>
          <div>
            <p>First Repayment amount</p>
            <p>no data</p>
          </div>
          <div>
            <p>Last Repayment Amount</p>
            <p>no data</p>
          </div>
          <div>
            <p>Overrude Maturity Date</p>
            <p>no data</p>
          </div>
          <div>
            <p>Overrude Each Repayment Amount</p>
            <p>no data</p>
          </div>
          <div>
            <p>Interest charged in loan Schedule</p>
            <p>no data</p>
          </div>
          <div>
            <p>Time to post between</p>
            <p>no data</p>
          </div>
        </div>
        <h2>Other Optionl</h2>
        <div className="other-optional">
        <div>
            <p>Guarantors</p>
            <p>no data</p>
          </div>
          <div>
            <p>Description</p>
            <p>no data</p>
          </div>
          <div>
            <p>Loan added on</p>
            <p>??</p>
          </div>
        </div> */}
      </div>
    </>
  );
};

export default LoanDetails;
